import(/* webpackMode: "eager" */ "/vercel/path0/app/federal/opportunities/page.tsx");
